import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { calendarActions } from '../../../modules/reducer/calendarSlice';
import selectors from '../../../modules/selectors/datePickerSelectors';

const DatePickerMenu = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { currQuarter, currYear, comparisonQuarter, comparisonYear } = useSelector(
    selectors.datePickerCombinedData
  );
  const [quarter, setQuarter] = useState('');
  const [year, setYear] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    props.timePeriod ? setQuarter(currQuarter) : setQuarter(comparisonQuarter);
    props.timePeriod ? setYear(currYear) : setYear(comparisonYear);
  });

  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    if (props.type === 'quarter' && props.timePeriod) {
      dispatch(calendarActions.getCurrentQuarter(option));
    } else if (props.type === 'year' && props.timePeriod) {
      dispatch(calendarActions.getCurrentYear(option));
    }

    if (props.type === 'quarter' && props.comparisonPeriod) {
      dispatch(calendarActions.getCompareCurrentQuarter(option));
    } else if (props.type === 'year' && props.comparisonPeriod) {
      dispatch(calendarActions.getCompareCurrentYear(option));
    }
    handleClose();
  };

  const ITEM_HEIGHT = 30;

  return (
    <div>
      <Button onClick={handleButtonClick} variant="text" color="secondary">
        {props.type === 'quarter' ? (quarter ?? 'Q4') : year}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '10ch',
            textAlign: 'center',
          },
        }}
      >
        {props?.data?.map((iter, _idx) => (
          <MenuItem
            key={iter}
            onClick={() => handleMenuItemClick(iter)}
            selected={props.type === 'quarter' ? iter === quarter : iter === year}
          >
            {iter}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

// Prop validation
DatePickerMenu.propTypes = {
  timePeriod: PropTypes.string,
  type: PropTypes.string,
  comparisonPeriod: PropTypes.bool,
  data: PropTypes.array,
};

export default DatePickerMenu;
